<template>
  <StackLayout :class="classes">
    <Label v-if="!hideLabel" class="label" :style="invalidStyle" :text="label" textWrap />
    <slot name="default" />
    <GridLayout v-if="invalid" class="error" columns="30, *">
      <AgIcon col="0" type="exclamationCircle" :color="errorColor" size="16" />
      <Label col="1" :style="invalidStyle" :text="error" />
    </GridLayout>
  </StackLayout>
</template>

<script>

import { colors } from '@/helpers/ui'

export default {
  props: {
    label: {
      type: String,
      default: '[label]'
    },
    hideLabel: {
      type: Boolean
    },    
    noMargin: {
      type: Boolean,
      default: false
    },
    value: {},
    rules: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: () => ({
    checkboxes: [],
    touched: false,
    error: false,
    errorColor: colors.error
  }),
  computed: {
    classes () {
      return {
        'checkbox-group': true,
        'control': true,
        'invalid': this.invalid,
        'no-margin': this.noMargin
      }
    },
    invalid () {
      if (!this.touched) {
        return false
      }

      return !this.validate()
    },
    invalidStyle () {
      return { color: this.invalid ? this.errorColor : null }
    }
  },
  watch: {
    invalid: {
      immediate: true,
      handler (to) {
        this.checkboxes.forEach(checkbox => {
          checkbox.setInvalid(to)
        })
      }
    }
  },
  methods: {
    findCheckboxes (children) {
      let checkboxes = []

      children = children || this.$children

      children.forEach(child => {
        checkboxes = checkboxes.concat(this.findCheckboxes(child.$children))
        
        if (child.$options.name === 'Checkbox') {
          checkboxes.push(child)
        }
      })

      return checkboxes
    },
    validate () {
      const values = []
      
      this.checkboxes.forEach(checkbox => {
        if (checkbox.isChecked) {
          values.push(checkbox.value)
        }
      })

      for (let i = 0; i < this.rules.length; ++i) {
        const result = this.rules[i](values)

        if (result !== true) {
          this.error = result

          return false
        }
      }

      return true
    },
    validateByForm () {
      this.touched = true

      return !this.invalid
    }
  },
  mounted () {
    this.checkboxes = this.findCheckboxes()
  }
}

</script>

<style lang="scss" scoped>

.label {
  color: #000000;
  font-weight: bold;
}

.ns-ios,
.ns-android {
  .error {
    margin-top: 10;
  }
}

html {
  .error {
    margin-top: 10px;
  }
}

</style>